import { useAsyncFn } from 'react-use';

import Session from 'supertokens-auth-react/recipe/session';

export const useSignOut = () => {
  return useAsyncFn(async () => {
    await Session.signOut();
  });
};
